module.exports = __webpack_public_path__ + "img/w21-b1.38d7c844.jpg";